
import { ref, defineComponent, onMounted, reactive } from 'vue'
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router'
import store from '@/store/'
import { axiosSetting } from '@/utils/axiosSetting'
import ModalSystemError from '@/components/genenral/ModalSystemError.vue'
import InputRadioButton from '@/components/elements/InputRadioButton.vue'
import Button from '@/components/elements/Button.vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')

export default defineComponent({
  name: 'CbtDetail',
  components: {
    Button,
    InputRadioButton,
    ModalSystemError
  },
  props: {
    currentIndex: {
      type: Number,
      default: 0
    }
  },

  beforeRouteEnter: (to: any, from: any, next: any) => {
    const ajax = axiosSetting('app', 'action')

    const previousPage = from.fullPath
    const previousComponent = from.name

    to.matched[0].props.default = {
      currentIndex: Number(to.params.qno) - 1
    }

    next(async (vm: any) => {
      const string = to.params.category
      const params = {
        users_id: vm.$store.state.userInfo.zip,
        year: '2022',
        term: Number(string.substring(string.length - 1)),
        flg: 's'
      }
      const data = await ajax
        .post('/api/v1/cbt_question', params)
        .then((res: any) => {
          return res.data
        })

      vm.$store.commit('setCbtQuestions', data)

      // リロード以外の正規の手段で問題を解き始めたとき
      if (
        previousPage == '/magazines/exam/cbt' ||
        previousComponent == 'examCbtResult' ||
        previousComponent == 'examCbtFail'
      ) {
        vm.timerStart()
        localStorage.setItem('startDate', vm.getCurrentTime())
      } else if (previousPage == '/') {
        // リロードのとき
        // 保存した時間からタイマースタート
        const savedTime = JSON.parse(localStorage.getItem('nowTime') + '')
        vm.leftMinutes = savedTime.minutes
        vm.leftSeconds = savedTime.seconds
        vm.timerStart()
      }
    })
  },

  beforeRouteUpdate: (to: any, from: any, next: any) => {
    const storeData = store.state.cbtQuestions
    if (to.params.qno == 0 || to.params.qno > storeData.length)
      return next('/404')
    to.matched[0].props.default = {
      currentIndex: Number(to.params.qno) - 1
    }
    next()
  },

  beforeRouteLeave: (to: any, from: any, next: any) => {
    localStorage.setItem('myAnswers', '')
    if (to.name !== 'examCbtResult' && to.name !== 'examCbtFail') {
      const answer = window.confirm(
        'ページを離脱してもよろしいですか？解答途中のデータは失われてしまいます。'
      )
      if (!answer) next(false)
    }
    next()
  },

  setup(props) {
    const router = useRouter()
    const route = useRoute()

    const myAnswers: any[] = reactive([])

    const selectedIndex = ref(null)
    const selectIndex = (e: any) => {
      selectedIndex.value = e
    }

    // タイマー系処理まとめ
    // タイマーのon/off管理ref
    const timerOn = ref(false)
    const timerInterval = ref()
    // 描画用のref
    const leftMinutes = ref(30)
    const leftSeconds = ref(0)
    // 終了関数
    // 時間切れの場合
    const timerOver = () => {
      clearInterval(timerInterval.value)
      router.push(`/magazines/exam/cbt/${route.params.category}/fail`)
    }
    // 時間内に終了した場合
    const timerEnd = () => {
      clearInterval(timerInterval.value)
    }
    // カウント関数。1秒ごとに実行
    const countDown = () => {
      if (leftSeconds.value <= 0 && leftMinutes.value >= 1) {
        leftMinutes.value--
        leftSeconds.value = 59
      } else if (leftSeconds.value <= 0 && leftMinutes.value <= 0) {
        timerOver()
      } else {
        leftSeconds.value--
      }
      const nowTime = {
        minutes: leftMinutes.value,
        seconds: leftSeconds.value
      }
      localStorage.setItem('nowTime', JSON.stringify(nowTime))
    }
    // 開始関数
    const timerStart = () => {
      timerInterval.value = setInterval(() => {
        countDown()
      }, 1000)
      timerOn.value = true
    }
    // 1→01にフォーマット処理
    const formatNumber = (n: number) => {
      return ('00' + n).slice(-2)
    }
    // ls保存用の日時取得
    const getCurrentTime = (): any => {
      return dayjs().format('YYYY/MM/DD HH:mm:ss')
    }

    onMounted(() => {
      // lsとmyAnswersを同期
      if (localStorage.getItem('myAnswers')) {
        const lsAnswers = JSON.parse(localStorage.getItem('myAnswers') + '')
        lsAnswers.forEach((element: any) => {
          myAnswers.push(element)
        })
      }
    })

    // ボタン押下時の処理
    const linkToResultText = ref('解答を送信する')
    const hasError = ref(false)
    const linkToResult = () => {
      linkToResultText.value = '送信中・・・'
      timerEnd()

      const answerSet = {
        qno: props.currentIndex + 1,
        wpqno: store.state.cbtQuestions[props.currentIndex].wpqno,
        answer: selectedIndex.value + ''
      }
      myAnswers.push(answerSet)
      // ここでapiにpostして成績送信する
      const string = route.params.category + ''
      const params = {
        users_id: store.state.userInfo.zip,
        year: '2022',
        term: Number(string.substring(string.length - 1)),
        flg: 'e',
        result: myAnswers,
        start_time: localStorage.getItem('startDate'),
        end_time: dayjs().format('YYYY/MM/DD HH:mm:ss')
      }
      const ajax = axiosSetting('app', 'action')
      ajax.post('/api/v1/cbt_question', params).then((res: any) => {
        if (res.status === 200) {
          // 成功した場合
          router.push(`/magazines/exam/cbt/${route.params.category}/result`)
        } else {
          // 失敗した場合
          hasError.value = true
          // 失敗したパターンの出力を試さないとわからない…
          // 想定されうるエラーパターンを洗い出す
          // 1. 時間切れだった場合
          console.log(res.err_msg)
        }
      })
    }
    const nextPage = () => {
      const answerSet = {
        qno: props.currentIndex + 1,
        wpqno: store.state.cbtQuestions[props.currentIndex].wpqno,
        answer: selectedIndex.value + ''
      }

      // 回答済みかチェック
      const answerIndex = myAnswers.findIndex(
        (item: any) => item.qno === props.currentIndex + 1
      )

      if (answerIndex !== -1) {
        // 既に回答済みの場合はlsを参照して値をセット（※2回戻って次へを押したとき対策
        myAnswers[answerIndex] = answerSet
        const nextAnswer = myAnswers[props.currentIndex + 1]
        selectedIndex.value = nextAnswer ? nextAnswer.answer : null
      } else {
        myAnswers.push(answerSet)
        selectedIndex.value = null
      }
      localStorage.setItem('myAnswers', JSON.stringify(myAnswers))
      router.push(
        `/magazines/exam/cbt/${route.params.category}/detail/${Number(
          route.params.qno
        ) + 1}`
      )
    }
    const previousPage = () => {
      const ls = JSON.parse(localStorage.getItem('myAnswers') + '')
      const previousAnswer = ls[props.currentIndex - 1].answer
      selectedIndex.value = previousAnswer

      router.push(
        `/magazines/exam/cbt/${route.params.category}/detail/${Number(
          route.params.qno
        ) - 1}`
      )
    }

    return {
      myAnswers,
      timerStart,
      getCurrentTime,
      selectedIndex,
      selectIndex,
      leftMinutes,
      leftSeconds,
      formatNumber,
      linkToResultText,
      hasError,
      linkToResult,
      nextPage,
      previousPage
    }
  }
})
